export const configMap = {
  BtradStat: {
    Rk: "排名",
    Player: "選手",
    PA: "打席",
    AB: "打數",
    H: "安打",
    '1B': "一壘安打",
    '2B': "二壘安打",
    '3B': "三壘安打",
    HR: "全壘打",
    BB: "四壞保送",
    SO: "三振",
    AVG: "打擊率",
    OBP: "上壘率",
    SLG: "長打率",
    OPS: "攻擊指數", 
    wOBA: "加權上壘率",
  },
  PtradStat: {
    Rk: "排名",
    Player: "選手",
    PA: "面對打席",
    AB: "面對打數",
    H: "被安打",
    '1B': "一壘安打",
    '2B': "二壘安打",
    '3B': "三壘安打",
    HR: "全壘打",
    BB: "四壞保送",
    SO: "三振",
    AVG: "被打擊率",
    OBP: "被上壘率",
    SLG: "被長打率",
    OPS: "打者攻擊指數", 
    wOBA: "加權被上壘率",
  },
  pitcher: {
    Rk: "排名",
    Player: "選手",
    '4-Seamer': "直球",
    Sinker: "伸卡",
    Cutter: "卡特",
    Slider: "滑球",
    Changeup: "變速",
    Curve: "曲球",
    Splitter: "指叉",
    Knuckle: "彈指",
    Unknown: "未知"
  },
  batter: {
    Rk: "排名",
    Player: "選手",
    Count: "球數",
    'LA(°)': "擊球仰角",
    'SwSp%': "甜蜜點比率",
    'EV Max': "最大擊球初速",
    'EV Avg': "平均擊球初速",
    'EV FB/LD': "擊球初速-飛球",
    'EV GD': "擊球初速-滾地球",
    //'DIST MAX': "最大擊球距離",
    //'DIST AVG': "平均擊球距離",
    'Whiff%': "揮空率",
    'Hard#': "強勁擊球顆數",
    'Hard%': "強勁擊球率",
    'Swing%': "揮棒率",
    'O-Swing%': "壞球追打率",
    'Contact%': "揮棒擊球率",
    'TSGNB': "強擊球顆數",
  },
  batterPR: {
    Rk: "排名",
    Player: "選手",
    'SwSp%': "甜蜜點比率",
    'EV Max': "最大擊球初速",
    'EV Avg': "平均擊球初速",
    'Whiff%': "揮空率",
    'Hard%': "強勁擊球率",
    'O-Swing%': "壞球追打率",
    'Contact%': "揮棒擊球率",
  }
}

export const pitchTypeMap = {
  'Pitch': "球種",
  '4-Seamer': "直球",
  Sinker: "伸卡",
  Cutter: "卡特",
  Slider: "滑球",
  Changeup: "變速",
  Curve: "曲球",
  Splitter: "指叉",
  Knuckle: "彈指",
  Unknown: "未知"
}

export const framesConfigMap = {
  batter: {tradstat: '一般數據統計', teststat: '測試會成績統計', teststatPR: '測試會成績PR值', teststatPR_Comp: '測試會與去年中職成績PR值'},
  pitcher: {tradstat: '一般數據統計', vAvg: '平均球速', vMax: '最大球速', spinAvg: '平均轉速', spinMax: '最大轉速', movement: '位移'},
  personPitcher: {statistic: '數據分析圖表', PbyP: '逐打席逐球數據'},
  personBatter: {statistic: '數據分析圖表', PbyP: '逐打席逐球數據'}
}

export const pitchMap = {
  "4-Seamer": "ball_fb",
  "Curve": "ball_cb",
  "Changeup": "ball_ch",
  "Sinker": "ball_ft",
  "Slider": "ball_sl",
  "Splitter": "ball_sp",
  "Cutter": "ball_ct",
  "Knuckle": "ball_kn",
  "Unknown": "ball_un"
}

export const pitchTypeTagMap = {
  "FB": "4-Seamer",
  "CB": "Curve",
  "CH": "Changeup",
  "SL": "Slider",
  "FT": "Sinker",
  "SP": "Splitter",
  "CT": "Cutter",
  "KN": "Knuckle",
  "UN": "Unknown",
}

export const PREntries = {
  'SwSp%': "甜蜜點比率",
  'EV Max': "最大擊球初速",
  'EV Avg': "平均擊球初速",
  'Whiff%': "Whiff%",
  'Hard%': "強勁擊球率",
  'O-Swing%': 'OSwing%',
  'Contact%': 'Contact%'
}

export const tableHeaderMap = {
  pitcherByPitchType: {
    'Pitch Type': '球種',
    'Velo': '均速',
    'Max. Velo': '極速',
    'RPM': '轉速',
    'Max. RPM': '最高轉速',
    'Vert. Break': '垂直位移',
    'Horz. Break': '水平位移',
    'Spin Eff.': '旋轉效率',
    'Gyro Deg.': 'Gyro角度',
    'Spin Dir.': '轉軸',
    'Strike%': '好球率'
  },
  overallOne: ['PA', 'AB', 'H', '1B', '2B', '3B', 'HR', 'SO', 'BB', 'AVG', 'wOBA', 'EV', 'Max. EV', 'LA', 'Whiff%'],
  overallTwo: ['Swing%', 'Z-Swing%', 'O-Swing%', 'Z-Contact%', 'Weak', 'Top', 'Under', 'Flare-Burner', 'Solid', 'Barrel']
}

export const pitchTagColorMap = {
  FB: "#FF0000",//FB
  CB: "#0080FF",//CB
  CH: "#007500",//CH
  FT: "#b62170",//FT
  SL: "#eee716", //#FFFF37",//SL
  SP: "#FF8000",//SP
  CT: "#613030",//CT
  SC: "#00f2ff",//SC
  SFF: "#D94600",//SFF
  KN: "#6F00D2",//KN
  OT: "#ADADAD",//OT
  UN: "#272727",//UN
}

export const pitchSpeedDistributionColorMap = {
  FB: {
    line: 'rgb(210, 45, 73)',
    background: 'rgba(210, 45, 73, 0.5)'
  },
  CB: {
    line: 'rgb(0, 209, 237)',
    background: 'rgba(0, 209, 237, 0.5)'
  },
  CH: {
    line: 'rgb(29, 190, 58)',
    background: 'rgba(29, 190, 58, 0.5)'
  },
  FT: {
    line: 'rgb(182, 33, 112)',
    background: 'rgba(182, 33, 112, 0.5)'
  },
  SL: {
    line: 'rgb(238, 231, 22)',
    background: 'rgba(1238, 231, 22, 0.5)'
  },
  SP: {
    line: 'rgb(59, 172, 172)',
    background: 'rgba(59, 172, 172, 0.5)'
  },
  CT: {
    line: 'rgb(147, 63, 44)',
    background: 'rgba(147, 63, 44, 0.5)'
  },
  SC: {
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
  SFF :{
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
  KN: {
    line: 'rgb(98, 54, 205)',
    background: 'rgba(98, 54, 205, 0.5)'
  },
  UN: {
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
  OT: {
    line: 'rgb(110, 10, 20)',
    background: 'rgba(110, 10, 20, 0.5)'
  },
}

export const BarrelTypeMap = {
  'Weak-Contact': 'weak',
  'Poorly-Topped': 'top',
  'Poorly-Under': 'under',
  'Flare-or-Burner': 'flareburner',
  'Solid-Contact': 'solid',
  'Barrel': 'barrel'
}

export const PitcherPRChartTitleMap = {
  AVGEV: 'Avg Exit Velovity',
  MAXEV: 'Max Exit Velocity',
  FBAVGV: 'Avg Fastball Velocity',
  FBAVGS: 'Avg Fastball Spin Rate',
  CBAVGS: 'Avg Curve Spin Rate',
  WHIFF: 'Whiff%',
  OSWING: 'Chase Rate',
  STRIKEP:'Strike%'
}

export const chartMap = {
  pr: ['Avg Exit Velocity', 'HardHit%', 'Whiff%', 'Max Exit Velocity', 'O-Swing%', 'Contact%'],

  prString: { 'Avg Exit Velocity': 'EV Avg', 'HardHit%': 'Hard%', 'Whiff%': 'Whiff%', 'Max Exit Velocity' :'EV Max', 'O-Swing%':'O-Swing%', 'Contact%':'Contact%'},
}

export const playerListIdentitiesMap = {
  pitcher: ['LHP', 'RHP'],
  batter: ['C', 'IF', 'OF']
}

export const playerTagIdentityMap = {
  'L': 'LHP',
  'R': 'RHP',
  'I': 'IF',
  'C': 'C',
  'O': 'OF'
}